export default __webpack_public_path__ + "static/media/img_baseRattle_grey.37561e14.jpg";